import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const scrollToVideo = () => {
    document.getElementById('vsl-video')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="py-24 bg-charcoal" data-id="element-33">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-35">
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-tight mb-8" data-id="element-36">
            We're not for everyone. If you're ready to work, ready to grow, and
            ready to do something that actually matters — apply.
          </h2>

          <button onClick={scrollToVideo} className="px-12 py-5 bg-maroon text-white font-bold text-xl rounded hover:bg-opacity-90 transition-colors mb-6" data-id="element-37">
            Finish video to see apply link
          </button>

          <p className="text-gray-400 text-sm italic" data-id="element-38">
            The application link is revealed at the end of Brock's video.
            Someone from our team will reach out within 48 hours of applying.
          </p>
        </motion.div>
      </div>
    </section>;
}